import { registerLocaleData } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientJsonpModule,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAnalyticsModule } from '@angular/fire/compat/analytics';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { GoogleMapsModule } from '@angular/google-maps';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ServiceWorkerModule } from '@angular/service-worker';
import { HipermercodeToolkitModule } from '@hipermercode-front/toolkit';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';

import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { OauthHttpInterceptor } from './app/core/helpers/oauth.http-interceptor';
import { PaellaDatabaseModule } from './app/paella-dabase.module';
import { PaellaSuperHttpClientModule } from './app/paella-super-http-client.module';
import { environment } from './environments';
import 'hammerjs';

registerLocaleData(localeEs, 'es');

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      HttpClientJsonpModule,
      BrowserModule,
      AppRoutingModule,
      PaellaDatabaseModule,
      HipermercodeToolkitModule.forRoot(environment),
      NgxSpinnerModule,
      PaellaSuperHttpClientModule,
      ServiceWorkerModule.register('combined-sw.js', { enabled: environment.production }),
      ServiceWorkerModule.register('firebase-messaging-sw.js', {
        enabled: environment.production,
      }),
      ToastrModule.forRoot(),
      AngularFireMessagingModule,
      AngularFireAnalyticsModule,
      AngularFireModule.initializeApp(environment.firebase),
      TranslateModule.forRoot({
        defaultLanguage: 'es',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
      GoogleMapsModule
    ),
    { provide: HTTP_INTERCEPTORS, useClass: OauthHttpInterceptor, multi: true },
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
  ],
})
  .then(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('firebase-messaging-sw.js');
    }
  })
  .catch((error: any) => console.error(error));
